// customerMessages.js (simulador · comida para llevar, 24/9/2026) — lo que RECIBE el cliente por
// WhatsApp, para las vistas previas de la demo. ESPEJO de apps/food-orders/src/utils/customerMessages.js:
// el cuerpo entre las marcas es IDÉNTICO (lo fija aws_lambdas/_shared_pedidos/customerMessagesCopies.test.js,
// que además lo compara con el servidor). El simulador enseña exactamente lo mismo que la app real.
// Los emojis de los textos son los de producción: es WhatsApp real, no la interfaz del CRM.

import { cartaTemplatePhoneParam as cartaTemplatePhoneParamLocal } from "./orderCancelCutoff";

// ── customerMessages: cuerpo compartido (inicio) ──

// Botones (≤ 20 caracteres, sin emojis: Meta los rechaza).
const BTN_CANCEL_ORDER = "Cancelar pedido";
const BTN_NEW_ORDER = "Nuevo pedido";
const BTN_PAY_ONLINE = "Pagar online";

// Mensaje con el botón «Ver carta y pedir» que abre el formulario (c_detectFoodOrderIntent): cabecera
// con el saludo, cuerpo, pie y botón. Por el número compartido el cuerpo lleva el prefijo del negocio.
const FLOW_INVITE_BODY =
  "Parece que quieres hacer un pedido. Pulsa el botón para ver nuestra carta y seleccionar lo que quieras. 🍽️";
const FLOW_INVITE_FOOTER = "Pedidos para llevar";
const FLOW_INVITE_CTA = "Ver carta y pedir";
function flowInviteHeader(name) {
  return name ? `¡Bienvenido a ${name}!` : "¡Hola!";
}

// Confirmación por PLANTILLA (pedido por la web o apuntado a mano). Recogida: pedido_confirmado_v4;
// domicilio: _v5 (la hora viaja con su etiqueta en {{4}}). En número compartido la _trial lleva el
// MISMO cuerpo (el negocio ya va en {{1}}).
const TPL_CONFIRM_PICKUP =
  "✅ *{{1}}* confirma tu pedido:\n\n{{2}}\n\n💰 Total: {{3}}\n🕐 Recogida: {{4}}\n\n¡Gracias por tu pedido, {{5}}! Te esperamos.";
const TPL_CONFIRM_DELIVERY =
  "✅ *{{1}}* confirma tu pedido:\n\n{{2}}\n\n💰 Total: {{3}}\n🕐 {{4}}\n\n¡Gracias por tu pedido, {{5}}! Ya estamos preparándolo.";
// Con cobro online (botones «Pagar online» + «Cancelar pedido»): pedido_confirmado_pago_v4 / _v5.
const TPL_CONFIRM_PICKUP_PAY =
  "✅ *{{1}}* confirma tu pedido:\n\n{{2}}\n\n💰 Total: {{3}}\n🕐 Recogida: {{4}}\n\n¡Gracias por tu pedido, {{5}}! Puedes pagarlo online con el botón de abajo.";
const TPL_CONFIRM_DELIVERY_PAY =
  "✅ *{{1}}* confirma tu pedido:\n\n{{2}}\n\n💰 Total: {{3}}\n🕐 {{4}}\n\n¡Gracias por tu pedido, {{5}}! Puedes pagarlo online con el botón de abajo.";
// Sin nombre de cliente el servidor cae a la v2 (4 parámetros, sin saludo por el nombre).
const TPL_CONFIRM_NONAME =
  "✅ *{{1}}* confirma tu pedido:\n\n{{2}}\n\n💰 Total: {{3}}\n🕐 Recogida: {{4}}\n\n¡Gracias por tu pedido!";
const TPL_CONFIRM_NONAME_PAY =
  "✅ *{{1}}* confirma tu pedido:\n\n{{2}}\n\n💰 Total: {{3}}\n🕐 Recogida: {{4}}\n\n¡Gracias por tu pedido! Puedes pagarlo online con el botón de abajo.";

// Avisos por plantilla en número compartido (variantes _trial: el nombre del negocio en {{1}}).
const TPL_CANCELLED_CONEXT =
  "⚠️ *{{1}}*\n\nLo sentimos, tu pedido ha sido cancelado.\n\nMotivo: {{2}}\n\nPara cualquier duda, escríbenos por este chat.";
const TPL_READY_CONEXT = "🍽️ *{{1}}*\n\nHola {{2}}, tu pedido ya está listo para recoger. ¡Te esperamos!";
const TPL_PICKED_UP_CONEXT = "🍽️ *{{1}}*\n\n¡Gracias por tu pedido, {{2}}! Esperamos que lo hayas disfrutado.";
const TPL_REVIEW_CONEXT =
  "📩 *{{1}}* te escribe:\n\nHola {{2}}, gracias por tu pedido. 🙌\n\n¿Nos dejas una reseña sobre tu experiencia? {{4}}\n\n👉 {{3}}\n\n¡Gracias por tu confianza!";

// Los mismos avisos con NÚMERO PROPIO (plantilla base en la WABA del negocio). Viven en
// c_sector_config (comida_para_llevar), fuera del repo: copiados de ahí el 24/9/2026; solo el de
// cancelación tiene además copia en admin_scripts/add_food_base_templates_to_sector_config.js.
const TPL_CANCELLED_OWN =
  "Tu pedido en *{{1}}* ha sido cancelado.\n\nMotivo: {{2}}\n\nDisculpa las molestias. Escríbenos por este chat para cualquier duda.";
const TPL_READY_OWN =
  "¡Hola {{1}}! 👋 Tu pedido ya está listo. 🍕\n\nSi todavía no lo has recogido, ¡te esperamos! Y si ya lo tienes, ¡que lo disfrutes! 😋\n\n¡Gracias por confiar en nosotros!";
const TPL_PICKED_UP_OWN =
  "¡Hola {{1}}! 😋 ¿Qué tal tu pedido? Esperamos que lo estés disfrutando muchísimo.\n\n¡Gracias por confiar en nosotros! 🙌";
const TPL_REVIEW_OWN =
  "¿Qué tal todo, {{1}}? Si te apetece, déjanos una reseña aquí 👉 {{2}}\n\n{{3}}\n\n¡Gracias por confiar en nosotros!";

/**
 * Teléfono LEGIBLE en lo que lee el cliente (24/9/2026): «+34 657 52 47 49»; un nacional español
 * sin prefijo pasa a +34; otros países, tal cual en E.164; un dato que no es teléfono, como estaba.
 * = readablePhone de c_detectFoodOrderIntent/closedMessages.js (formatPhoneForMessage del corte).
 */
function readablePhone(raw) {
  const s = String(raw == null ? "" : raw).trim();
  if (!s) return "";
  const clean = s.replace(/[\s.()-]/g, "");
  const e164 = /^[6-9]\d{8}$/.test(clean) ? `+34${clean}` : clean;
  if (!/^\+[1-9]\d{7,14}$/.test(e164)) return s;
  const es = /^\+34(\d{3})(\d{2})(\d{2})(\d{2})$/.exec(e164);
  return es ? `+34 ${es[1]} ${es[2]} ${es[3]} ${es[4]}` : e164;
}

// Cuando el cliente quiere pedir y hoy no se puede (c_detectFoodOrderIntent/closedMessages.js).
function noMenuTodayText(phone) {
  const tel = readablePhone(phone);
  return tel
    ? `Hoy todavía no hemos publicado la carta 😔. Puedes llamarnos al ${tel} y te contamos. ¡Gracias!`
    : "Hoy todavía no hemos publicado la carta. Escríbenos un poco más tarde y te la enviamos. ¡Gracias! 😊";
}
function notAcceptingText(phone) {
  const tel = readablePhone(phone);
  return tel
    ? `Ahora mismo no estamos aceptando pedidos 😔. Puedes llamarnos al ${tel}. ¡Gracias!`
    : "Ahora mismo no estamos aceptando pedidos. Vuelve a escribirnos dentro de nuestro horario. ¡Gracias! 😊";
}

/**
 * Qué avisos de Mensajes automáticos recibirá el cliente DESPUÉS de un pedido (24/9/2026). Mismo
 * criterio que schedulePickupReminders de c_createPedido / c_createPublicOrder: interruptor
 * general `pickup_reminders.enabled`; reminders[0] = «Pedido listo» (no a domicilio);
 * reminders[1] = reseña (solo con enlace de Google). Devuelve los minutos después de la hora
 * (null si no se envía). El pedido manual ya no tiene su propio interruptor: c_createPedido
 * ignoraba `send_reminder` y mandaba esto.
 */
function autoMessagesAfterOrder({ pickupReminders, hasReviewLink = false, isDelivery = false } = {}) {
  const pr = pickupReminders && typeof pickupReminders === "object" ? pickupReminders : null;
  const list = pr && pr.enabled && Array.isArray(pr.reminders) ? pr.reminders : [];
  const mins = (r) => {
    const m = Number(r && r.minutes_after_pickup);
    return r && r.enabled && Number.isFinite(m) && m >= 0 ? m : null;
  };
  return {
    ready: isDelivery ? null : mins(list[0]),
    review: hasReviewLink ? mins(list[1]) : null,
  };
}

/** 15 → «15 min»; 60 → «1 h»; 90 → «1 h 30 min». */
function formatAfterMinutes(m) {
  const n = Math.round(Number(m) || 0);
  if (n < 60) return `${n} min`;
  const h = Math.floor(n / 60);
  const r = n % 60;
  return r ? `${h} h ${r} min` : `${h} h`;
}

/** La línea informativa del pedido manual, en español (la app; el simulador la traduce). */
function autoMessagesAfterOrderText(opts) {
  const { ready, review } = autoMessagesAfterOrder(opts);
  const parts = [];
  if (ready !== null) {
    parts.push(ready === 0 ? "«Pedido listo» a la hora de recogida" : `«Pedido listo» ${formatAfterMinutes(ready)} después de la hora de recogida`);
  }
  if (review !== null) {
    parts.push(review === 0 ? "la petición de reseña a la hora del pedido" : `la petición de reseña ${formatAfterMinutes(review)} después`);
  }
  return parts.length
    ? `Después le llegará ${parts.join(" y ")}.`
    : "Después no le llegará ningún aviso automático.";
}

// Motivo con el que se cancela solo un pedido que no se pagó a tiempo (c_expireUnpaidOrder).
const EXPIRE_REASON = "No se recibió el pago a tiempo";

// Difusión de la carta con Formulario (plantilla `cartadiaflow`, APROBADA en Meta). Su texto vive en
// c_sector_config (fuera del repo): copiado el 24/9/2026. {{telefono}} = el «Teléfono que verán tus
// clientes» o, sin él, el relleno de cartaTemplatePhoneParam (orderCancelCutoff.js).
const TPL_CARTA_DIA_FLOW =
  "Hola {{nombre}},\n\nYa tenemos disponible nuestra carta 🍽️. Pulsa el botón para ver los platos y hacer tu pedido por WhatsApp 👇\n\nTambién puedes realizar el pedido llamando al {{telefono}}.\n\n¡Hasta pronto! 👋";

/**
 * Texto LIBRE (no plantilla) por el número compartido: c_sendMessage le antepone el negocio para que
 * el cliente sepa quién le escribe (prefixWithBusinessName). Afecta a la confirmación del Flow y a
 * las respuestas al pulsar «Cancelar pedido». Con número propio el texto va tal cual.
 */
function withConextPrefix(text, business) {
  return `📩 *${business || "Tu negocio"}* te escribe:\n\n${text}`;
}

/** {{n}} → params[n-1]; un hueco sin valor se queda como está. */
function fillTemplate(body, params) {
  const list = Array.isArray(params) ? params : [];
  return String(body).replace(/\{\{(\d+)\}\}/g, (m, n) => {
    const v = list[Number(n) - 1];
    return v === undefined || v === null ? m : String(v);
  });
}

/** Cierre de la petición de reseña (c_sendPickupReminder): con descuento o sin él. */
function reviewClause(discount) {
  const d = String(discount || "").trim();
  return d ? `Como agradecimiento, ${d} 🎁` : "¡Tu opinión nos ayuda muchísimo! 🙏";
}

function euros(cents) {
  return `${(Number(cents || 0) / 100).toFixed(2).replace(".", ",")} €`;
}

/** Importe en euros, formato español: «14,00 €» (formatEurosAmount del servidor, 24/9/2026). */
function eurosAmount(n) {
  return `${Number(n || 0).toFixed(2).replace(".", ",")} €`;
}

// ── Opciones de plato (29/9/2026) ──
// Mismo texto que dishOptions.lineOptionsText del servidor (el test de copias lo compara).
// compact → «Res, +Guacamole, sin lechuga» ({{2}} de la plantilla); normal → «Res · + Guacamole ·
// Sin lechuga» (segunda línea de la confirmación del Flow). Las opciones nulas o sin nombre se
// descartan: el servidor nunca las guarda en la línea del pedido.
function optionsLineText(line, compact) {
  const list = Array.isArray(line && line.options) ? line.options : [];
  const lf = (s) => {
    const str = String(s || "");
    if (str.length > 1 && str[1] === str[1].toUpperCase() && str[1] !== str[1].toLowerCase()) return str;
    return str.charAt(0).toLowerCase() + str.slice(1);
  };
  return list.filter((o) => o && String(o.name == null ? "" : o.name).trim()).map((o) => {
    if (o.kind === "remove") return `${compact ? "sin" : "Sin"} ${lf(o.name)}`;
    if (o.kind === "extras") return compact ? `+${o.name}` : `+ ${o.name}`;
    return o.name;
  }).join(compact ? ", " : " · ");
}

// = sanitizeTemplateParamText (c_sendTemplate/templateParamText.js), sin el recorte de emergencia:
// saltos → « · », tabs → espacio, rachas de espacios → uno, sin separador al principio ni al final.
function flatTemplateParam(value) {
  const sep = " · ";
  let s = String(value == null ? "" : value)
    .replace(/[ \t]*(?:\r?\n)+[ \t]*/g, sep)
    .replace(/\t+/g, " ")
    .replace(/ {2,}/g, " ");
  while (s.startsWith(sep)) s = s.slice(sep.length);
  while (s.endsWith(sep)) s = s.slice(0, -sep.length);
  return s.trim();
}

// Tope del cuerpo del mensaje interactivo = INTERACTIVE_BODY_MAX de flowOrderConfirmation.js. Si la
// confirmación se pasa, las segundas líneas de opciones se degradan como en el servidor
// (fitSummaryToBudget): 1) completas; 2) compactas (solo nombres, «, », recorte a 40 con «…»);
// 3) se quitan por el final las que no entran + OPTIONS_NOTE. Las líneas de los platos, nunca.
const INTERACTIVE_BODY_MAX = 950;
const OPTIONS_NOTE = "Las opciones de tu pedido las ve el negocio.";
const OPTIONS_COMPACT_MAX = 40;

function compactOptionsLine(line) {
  const names = line.trim().split(" · ").map((t) => t.replace(/^\+ /, ""));
  const text = names.join(", ");
  return `   ${text.length > OPTIONS_COMPACT_MAX ? `${text.slice(0, OPTIONS_COMPACT_MAX - 1).trimEnd()}…` : text}`;
}

function fitSummaryToBudget(summary, budget) {
  const lines = String(summary).split("\n");
  const idx = lines.map((l, k) => (l.startsWith("   ") ? k : -1)).filter((k) => k >= 0);
  if (!idx.length || summary.length <= budget) return summary;
  const compact = lines.map((l, k) => (idx.includes(k) ? compactOptionsLine(l) : l));
  if (compact.join("\n").length <= budget) return compact.join("\n");
  const keep = [...idx];
  const render = () => `${compact.filter((_, k) => !idx.includes(k) || keep.includes(k)).join("\n")}\n${OPTIONS_NOTE}`;
  while (keep.length && render().length > budget) keep.pop();
  return render();
}

/**
 * Confirmación del pedido hecho con el FORMULARIO de WhatsApp (texto libre + botones «Cancelar
 * pedido» y «Nuevo pedido»). lines: [{ name, qty, price (unitario), ration?, options? }]. pickupCaption: la
 * hora («14:00», «Lo antes posible (aprox. 20:25–20:35)» con asap, «aprox. 20:25–20:35» a
 * domicilio). delivery: null (recogida) o { address, feeCents }.
 */
function flowConfirmText({ lines, pickupCaption, asap = false, delivery = null }) {
  const items = Array.isArray(lines) ? lines : [];
  const summary = items.map((i) => {
    const lineTotal = eurosAmount(Number(i.price) * Number(i.qty));
    const line = `• ${i.name}${i.ration === "media" ? " · media" : ""} × ${i.qty} — ${lineTotal}`;
    // Opciones de plato: «   Res · + Guacamole · Sin lechuga» debajo, aplanada (cartaDiaConfirmSummary).
    const opts = optionsLineText(i, false).replace(/\s+/g, " ").trim();
    return opts ? `${line}\n   ${opts}` : line;
  }).join("\n");
  const itemsTotal = items.reduce((n, i) => n + Number(i.price) * Number(i.qty), 0);
  const caption = String(pickupCaption || "").trim() || "Por confirmar";
  let when;
  let total = itemsTotal;
  let closing = "¡Te esperamos!";
  if (!delivery) {
    when = asap ? `🕐 ${caption}` : `🕐 Hora de recogida: ${caption}`;
  } else {
    const fee = Math.round(Number(delivery.feeCents || 0));
    total = Math.round((itemsTotal + fee / 100) * 100) / 100;
    const shipping = fee > 0 ? `🚚 Envío: ${euros(fee)}` : "🚚 Envío gratis";
    when = `🛵 Entrega a domicilio: ${caption}\n📍 ${delivery.address || ""}\n${shipping}`;
    closing = "¡Gracias por tu pedido!";
  }
  // = cartaDiaConfirmMessage: si el total pasa del tope, se ajustan las segundas líneas de opciones.
  const build = (sum) => `🎉 ¡Pedido confirmado!\n\n${sum}\n\n${when}\n💰 Total: ${eurosAmount(total)}\n\n${closing}`;
  const full = build(summary);
  if (full.length <= INTERACTIVE_BODY_MAX) return full;
  return build(fitSummaryToBudget(summary, INTERACTIVE_BODY_MAX - (full.length - summary.length)));
}

/**
 * Confirmación por PLANTILLA (web y pedido apuntado a mano). {{2}} = «2× Paella, 1× Croquetas»
 * (+ «, Promoción · Nombre −2,00 €» si hay promoción), {{3}} = «24,00 €». delivery: null o
 * { address }. pay: con cobro online. Sin nombre → la v2.
 */
function templateConfirmText({ business, lines, total, pickupCaption, customerName, delivery = null, pay = false, promo = null }) {
  const base = (Array.isArray(lines) ? lines : []).map((i) => {
    const opts = optionsLineText(i, true);
    return `${i.qty}× ${i.name}${i.ration === "media" ? " · media" : ""}${opts ? ` (${opts})` : ""}`;
  }).join(", ");
  // c_sendTemplate sanea todo parámetro (sanitizeTemplateParamText): nada de saltos en {{2}}.
  const summary = flatTemplateParam(promo ? `${base}, Promoción · ${promo.nombre} −${eurosAmount(promo.importe)}` : base);
  const time = String(pickupCaption || "").trim() || "por confirmar";
  const when = delivery
    ? `Entrega a domicilio: ${time}${delivery.address ? ` · ${delivery.address}` : ""}`
    : time;
  const name = String(customerName || "").trim();
  const body = !name
    ? (pay ? TPL_CONFIRM_NONAME_PAY : TPL_CONFIRM_NONAME)
    : delivery
      ? (pay ? TPL_CONFIRM_DELIVERY_PAY : TPL_CONFIRM_DELIVERY)
      : (pay ? TPL_CONFIRM_PICKUP_PAY : TPL_CONFIRM_PICKUP);
  return fillTemplate(body, [business, summary, eurosAmount(total), when, name]);
}

/**
 * Aviso de pago recibido con la conversación abierta (texto libre de c_stripeConnectWebhook,
 * paidNotice.js) para un pedido de HOY. amountEuros: lo cobrado. pickupTime «HH:MM» o nada.
 */
function paidNoticeText({ name, amountEuros, pickupTime, delivery = false }) {
  const who = String(name || "").trim() || "Cliente";
  const amount = eurosAmount(amountEuros);
  const t = String(pickupTime || "").trim();
  const verb = delivery ? "Te lo llevamos" : "Te esperamos";
  const closing = /^([01]\d|2[0-3]):([0-5]\d)$/.test(t)
    ? `${verb} a las ${t}.`
    : (delivery ? "Te lo llevamos en cuanto esté listo." : "Te avisamos en cuanto esté listo.");
  return `✅ Pago recibido, ${who}. Hemos cobrado ${amount} de tu pedido. ${closing} ¡Gracias!`;
}

// Lo que contesta el WhatsApp cuando el cliente pulsa «Cancelar pedido» (español; también hay
// valenciano en el servidor). El del corte por tiempo lo compone orderCancelCutoff.js.
const CANCEL_REPLIES = {
  cancelled: "✅ Tu pedido ha sido cancelado correctamente. Si tienes cualquier duda, estamos aquí para ayudarte.",
  cancelled_refund: "✅ Tu pedido ha sido cancelado. Como ya lo habías pagado online, el negocio te devolverá el importe en la misma tarjeta. Si tienes cualquier duda, escríbenos aquí.",
  already_cancelled: "Tu pedido ya estaba cancelado. Si quieres pedir otra cosa, escríbenos aquí.",
  not_cancelable: "Lo sentimos, tu pedido ya está en preparación y no es posible cancelarlo. Si necesitas ayuda, escríbenos aquí y te atendemos.",
  not_found: "No hemos encontrado tu pedido. Si necesitas ayuda, escríbenos aquí.",
};

/**
 * Recuadro lateral del ticket PNG: «RECOGIDA 12:30» / «ENTREGA 20:30» (antes un número inventado).
 * pickupTime es la hora real de inicio (con «lo antes posible», el inicio del tramo).
 */
function ticketStub({ pickupTime, fulfillment } = {}) {
  const time = String(pickupTime || "").trim();
  if (!time) return { label: "Pedido", value: "—" };
  return { label: fulfillment === "delivery" ? "Entrega" : "Recogida", value: time };
}

/** Tamaño de la hora en el recuadro (px sobre el ticket real de 1200 px de ancho). */
function ticketStubFontSize(value) {
  const n = String(value || "").length;
  return n <= 5 ? 56 : n <= 7 ? 40 : 28;
}

// ── customerMessages: cuerpo compartido (fin) ──

export {
  BTN_CANCEL_ORDER,
  BTN_NEW_ORDER,
  BTN_PAY_ONLINE,
  FLOW_INVITE_BODY,
  FLOW_INVITE_FOOTER,
  FLOW_INVITE_CTA,
  flowInviteHeader,
  TPL_CONFIRM_PICKUP,
  TPL_CONFIRM_DELIVERY,
  TPL_CONFIRM_PICKUP_PAY,
  TPL_CONFIRM_DELIVERY_PAY,
  TPL_CONFIRM_NONAME,
  TPL_CONFIRM_NONAME_PAY,
  TPL_CANCELLED_CONEXT,
  TPL_READY_CONEXT,
  TPL_PICKED_UP_CONEXT,
  TPL_REVIEW_CONEXT,
  TPL_CANCELLED_OWN,
  TPL_READY_OWN,
  TPL_PICKED_UP_OWN,
  TPL_REVIEW_OWN,
  EXPIRE_REASON,
  CANCEL_REPLIES,
  fillTemplate,
  withConextPrefix,
  reviewClause,
  flowConfirmText,
  templateConfirmText,
  paidNoticeText,
  ticketStub,
  ticketStubFontSize,
  readablePhone,
  noMenuTodayText,
  notAcceptingText,
  autoMessagesAfterOrder,
  formatAfterMinutes,
  autoMessagesAfterOrderText,
  TPL_CARTA_DIA_FLOW,
};

// Textos con el «Teléfono que verán tus clientes» (24/9/2026). Viven en orderCancelCutoff.js, cuyo
// cuerpo es IDÉNTICO al del servidor (fulfillmentCopies.test.js): se re-exportan aquí para que TODAS
// las vistas previas tiren de este fichero. Con número → «llámanos al +34 657 52 47 49»; sin él →
// «escríbenos por este chat» (y en plantillas, un relleno válido para Meta).
export {
  contactPhoneText,
  deliveryUnavailableMessage as deliveryUnavailableText,
  flowOrderErrorMessage as flowOrderErrorText,
  cartaTemplatePhoneParam,
} from "./orderCancelCutoff";

/** La difusión `cartadiaflow` tal como le llega al cliente (con número o con el relleno). */
export function cartaDiaFlowBroadcastText({ name, phone }) {
  return TPL_CARTA_DIA_FLOW
    .replace("{{nombre}}", name || "")
    .replace("{{telefono}}", cartaTemplatePhoneParamLocal("cartadiaflow", phone));
}
